webpackJsonp([37],{

/***/ 1011:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_accounting_filter_vue__ = __webpack_require__(945);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ed2bbb2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_accounting_filter_vue__ = __webpack_require__(1014);
function injectStyle (ssrContext) {
  __webpack_require__(1012)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2ed2bbb2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_accounting_filter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ed2bbb2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_accounting_filter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1012:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1013);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(721)("70aca855", content, true, {});

/***/ }),

/***/ 1013:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(720)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:AvenirRegular;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Regular.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:AvenirBold;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Bold.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:AvenirDemi;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Demi.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.full-width[data-v-2ed2bbb2]{width:100%}.filter-company[data-v-2ed2bbb2]{margin:0 30px 0 0}@media(max-width:768px){.filter-company[data-v-2ed2bbb2]{margin:0 0 30px}}", "", {"version":3,"sources":["/opt/build/repo/src/components/accounting-plans/accounting-filter.vue"],"names":[],"mappings":"AACA,WAAW,0BAA4B,6DAA6D,gBAAmB,kBAAkB,iBAAiB,CACzJ,AACD,WAAW,uBAAyB,0DAA0D,gBAAmB,kBAAkB,iBAAiB,CACnJ,AACD,WAAW,uBAAyB,0DAA0D,gBAAmB,kBAAkB,iBAAiB,CACnJ,AACD,WAAW,yBAA2B,0CAA0C,gBAAmB,iBAAiB,CACnH,AACD,WAAW,sBAAwB,uCAAuC,gBAAmB,iBAAiB,CAC7G,AACD,WAAW,uBAAyB,wCAAwC,gBAAmB,iBAAiB,CAC/G,AACD,WAAW,0BAA4B,8CAA8C,gBAAmB,iBAAiB,CACxH,AACD,WAAW,uBAAyB,2CAA2C,gBAAmB,iBAAiB,CAClH,AACD,WAAW,2BAA6B,+CAA+C,gBAAmB,iBAAiB,CAC1H,AACD,WAAW,wBAA0B,4CAA4C,gBAAmB,iBAAiB,CACpH,AACD,6BAA6B,UAAU,CACtC,AACD,iCAAiC,iBAAiB,CACjD,AACD,wBACA,iCAAiC,eAAiB,CACjD,CACA","file":"accounting-filter.vue","sourcesContent":["\n@font-face{font-family:\"AvenirRegular\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Regular.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"AvenirBold\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Bold.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"AvenirDemi\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Demi.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"Lato_regular\";src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_bold\";src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_light\";src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_regular\";src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_bold\";src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_semibold\";src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_light\";src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:normal;font-style:normal\n}\n.full-width[data-v-2ed2bbb2]{width:100%\n}\n.filter-company[data-v-2ed2bbb2]{margin:0 30px 0 0\n}\n@media(max-width: 768px){\n.filter-company[data-v-2ed2bbb2]{margin:0 0 30px 0\n}\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1014:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('general-filter',{staticClass:"layout wrap",class:{ 'column px-0' : _vm.column, 'px-5 mt-4' : !_vm.column }},[(!_vm.hidenCompany)?_c('v-flex',{staticClass:"filter-company",class:{ 'sm3' : !_vm.column, 'full-width' : _vm.column },attrs:{"xs12":""}},[_c('BaseSelect',{attrs:{"autocomplete":"","return-object":"","item-text":"name","item-value":"id","label":"Empresa","height":33,"items":_vm.companies,"value":_vm.newSubsidiaryId},on:{"input":function($event){return _vm.setData($event, 'subsidiaryId')}}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"filter-company",class:{ 'sm3' : !_vm.column, 'full-width' : _vm.column },attrs:{"xs12":""}},[_c('BaseSelect',{attrs:{"solo":"","return-object":"","label":"Año","item-text":"year","item-value":"id","disabled":_vm.disabledYears,"height":33,"items":_vm.years,"value":_vm.newYearId},on:{"input":function($event){return _vm.setData($event, 'yearAccountantId')}}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1123:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_accounting_plans_accounting_filter__ = __webpack_require__(1011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_app_tooltip_button__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_action_bar_action_bar__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_app_actions_app_actions__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_shared_back_button_route__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(20);




var changePage = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(page) {
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						this.currentPage = page;
						_context.next = 3;
						return this.loadAccounting();

					case 3:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function changePage(_x) {
		return _ref.apply(this, arguments);
	};
}();

var loadAccounting = function () {
	var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
		var response;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						_context2.prev = 0;

						this.params.page = this.currentPage;
						_context2.next = 4;
						return this.$http.get('com-accounting-plan', { params: this.params });

					case 4:
						response = _context2.sent;

						this.itemsTotalQuantity = Number(response.headers['x-quantity']);
						this.rows = response.data;
						this.lastPage = Number(response.headers['x-last-page']);
						_context2.next = 13;
						break;

					case 10:
						_context2.prev = 10;
						_context2.t0 = _context2['catch'](0);

						this.showGenericError();

					case 13:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this, [[0, 10]]);
	}));

	return function loadAccounting() {
		return _ref4.apply(this, arguments);
	};
}();

var loadCompanies = function () {
	var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
		var _this = this;

		var _ref6, value;

		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						_context3.next = 2;
						return this.$http.get('subsidiary');

					case 2:
						_ref6 = _context3.sent;
						this.companies = _ref6.data;

						if (this.subsidiaryId) {
							value = this.companies.find(function (c) {
								return c.id === _this.subsidiaryId;
							}) || {};

							this.params.subsidiaryId = this.subsidiaryId;
							this.subsidiaryName = value.name;
							this.loadYear(this.params.subsidiaryId);
						} else {
							this.loadAccounting();
						}

					case 5:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this);
	}));

	return function loadCompanies() {
		return _ref5.apply(this, arguments);
	};
}();

var loadYear = function () {
	var _ref7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
		var _ref8;

		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
			while (1) {
				switch (_context4.prev = _context4.next) {
					case 0:
						_context4.next = 2;
						return this.$http.get('com-year-accountant');

					case 2:
						_ref8 = _context4.sent;
						this.years = _ref8.data;

						this.loadAccounting();

					case 5:
					case 'end':
						return _context4.stop();
				}
			}
		}, _callee4, this);
	}));

	return function loadYear() {
		return _ref7.apply(this, arguments);
	};
}();

var onClone = function () {
	var _ref9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
			while (1) {
				switch (_context5.prev = _context5.next) {
					case 0:
						_context5.prev = 0;
						_context5.next = 3;
						return this.$http.post('com-accounting-plan/' + this.cloneId + '/clone', this.clone);

					case 3:
						this.showNotification(this.clone.description + ' se clon\xF3 correctamente');
						this.closeModal();
						this.loadAccounting();
						_context5.next = 11;
						break;

					case 8:
						_context5.prev = 8;
						_context5.t0 = _context5['catch'](0);

						this.showGenericError();

					case 11:
					case 'end':
						return _context5.stop();
				}
			}
		}, _callee5, this, [[0, 8]]);
	}));

	return function onClone() {
		return _ref9.apply(this, arguments);
	};
}();

var deleteAccountPlan = function () {
	var _ref12 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
			while (1) {
				switch (_context6.prev = _context6.next) {
					case 0:
						_context6.prev = 0;
						_context6.next = 3;
						return this.$http.delete('com-acounting-plan/' + this.accountPlanDeletion.id);

					case 3:
						this.closeModalDelete();
						this.loadCompanies();
						_context6.next = 10;
						break;

					case 7:
						_context6.prev = 7;
						_context6.t0 = _context6['catch'](0);

						if (_context6.t0.data.statusCode === 400 && _context6.t0.data.message === 'ACCOUNTING_PLAN_RELATION') {
							this.showGenericError('No se Puede eliminar un Plan Asociado');
						} else {
							this.showGenericError();
						}

					case 10:
					case 'end':
						return _context6.stop();
				}
			}
		}, _callee6, this, [[0, 7]]);
	}));

	return function deleteAccountPlan() {
		return _ref12.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








function created() {
	this.loadCompanies();
}

function closeModal() {
	this.modal = false;
	this.titleModal = '';
	this.cloneId = '';
	this.clone.year = '';
	this.clone.description = '';
	this.clone.code = '';
	this.clone.customerId = '';
	this.clone.subsidiaryId = '';
}

function edit(id) {
	var subsidiaryId = this.subsidiaryId || null;
	this.goTo('accounting-edit', { params: { subsidiaryId: subsidiaryId, id: id } });
}

function filterRows(_ref2) {
	var value = _ref2.value,
	    model = _ref2.model;

	this.params[model] = value.id;
	if (model === 'subsidiaryId') {
		this.subsidiaryName = value.name;
		this.params.yearAccountantId = null;
		this.loadYear(this.params.subsidiaryId);
	} else {
		this.loadAccounting();
	}
}

function goToDetail(_ref3) {
	var id = _ref3.id,
	    description = _ref3.description,
	    subsidiary = _ref3.subsidiary,
	    year = _ref3.year;

	this.goTo('accounting-accounts', { params: {
			id: id,
			name: description,
			subsidiaryName: subsidiary.name,
			year: year
		}
	});
}

function onSearchPlan(value) {
	this.params.search = value || null;
	this.loadAccounting();
}

function openModal(_ref10) {
	var id = _ref10.id,
	    year = _ref10.year,
	    description = _ref10.description,
	    code = _ref10.code,
	    customerId = _ref10.customerId,
	    subsidiaryId = _ref10.subsidiaryId;

	this.titleModal = '\xBFDeseas Clonar este Plan de Cuentas: "' + description + '"?';
	this.modal = true;
	this.clone.year = year;
	this.clone.description = description;
	this.clone.code = code;
	this.clone.customerId = customerId;
	this.clone.subsidiaryId = subsidiaryId;
	this.cloneId = id;
}

function runAction(_ref11) {
	var code = _ref11.code,
	    codeWeb = _ref11.codeWeb;

	if (code === 'activate-accounting-plan') {
		var params = {};
		if (this.params.subsidiaryId && this.params.yearAccountantId) {
			params.subsidiaryId = this.params.subsidiaryId;
			params.yearAccountantId = this.params.yearAccountantId;
		} else if (this.params.subsidiaryId) {
			params.subsidiaryId = this.params.subsidiaryId;
		} else if (this.params.yearAccountantId) {
			params.yearAccountantId = this.params.yearAccountantId;
		}
		this.goTo(codeWeb, { params: params });
	} else if (code === 'accounting-plan-new') {
		var subsidiaryId = this.params.subsidiaryId || null;
		this.goTo('accounting-new', { params: { subsidiaryId: subsidiaryId } });
	}
}

function subsidiaryName(name) {
	var base = this.$route.meta.title;
	this.title = name ? name + ' - ' + base : base;
}

function valuesDisabled() {
	var disabled = !this.subsidiaryName;
	return [{ code: 'accounting-plan-new', disabled: disabled }];
}

function goToBack() {
	this.goTo('companies');
}

function currentSubsidiary(newSub) {
	this.goTo('accounting-plans', { params: { subsidiaryId: newSub.id } });
}

// These functionalities are related to deleting account plans.
function confirmAccountPlanDeletion(row) {
	this.accountPlanDeletion = row;
	this.actionDeleteModal.titleModal = '\xBFEst\xE1 seguro de que desea eliminar el Plan de Cuentas: "' + row.description + '"?';
	this.actionDeleteModal.modal = true;
}

function closeModalDelete() {
	this.accountPlanDeletion = {};
	this.actionDeleteModal.titleModal = '';
	this.actionDeleteModal.modal = false;
}

function data() {
	return {
		companies: [],
		rows: [],
		lastPage: 0,
		currentPage: 1,
		columns: [{ id: 1, name: 'Plan de Cuentas', value: 'name', visible: true, checked: true, movil: true }, { id: 2, name: 'Empresa', value: 'subsidiary', visible: true, checked: true, movil: false }, { id: 3, name: 'Año Contable', value: 'year-accountant', visible: true, checked: true, movil: true }, { id: 3, name: 'Estado', value: 'state', visible: true, checked: true, movil: true }, { id: 4, name: 'Acción', value: 'action', visible: true, checked: true, movil: false }],
		disabledAction: true,
		years: [],
		companyId: 0,
		modal: false,
		titleModal: '',
		itemsTotalQuantity: null,
		clone: {
			year: '',
			description: '',
			code: '',
			customerId: '',
			subsidiaryId: ''
		},
		cloneId: '',
		subsidiaryName: '',
		title: this.$route.meta.title,
		iconWidth: 25,
		actionDeleteModal: {
			modal: false,
			titleModal: ''
		},
		accountPlanDeletion: {}
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'page-accounting-plans',
	components: {
		accountingFilter: __WEBPACK_IMPORTED_MODULE_3__components_accounting_plans_accounting_filter__["a" /* default */],
		appTooltipButton: __WEBPACK_IMPORTED_MODULE_4__components_shared_app_tooltip_button__["a" /* default */],
		actionBar: __WEBPACK_IMPORTED_MODULE_5__components_shared_action_bar_action_bar__["a" /* default */],
		appActions: __WEBPACK_IMPORTED_MODULE_6__components_shared_app_actions_app_actions__["a" /* default */],
		backButtonRoute: __WEBPACK_IMPORTED_MODULE_7__components_shared_back_button_route__["a" /* default */]
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])('subsidiary', ['currentSubsidiary']), {
		valuesDisabled: valuesDisabled
	}),
	created: created,
	data: data,
	methods: {
		changePage: changePage,
		closeModal: closeModal,
		edit: edit,
		filterRows: filterRows,
		goToDetail: goToDetail,
		loadAccounting: loadAccounting,
		loadCompanies: loadCompanies,
		loadYear: loadYear,
		onClone: onClone,
		onSearchPlan: onSearchPlan,
		openModal: openModal,
		runAction: runAction,
		goToBack: goToBack,
		confirmAccountPlanDeletion: confirmAccountPlanDeletion,
		closeModalDelete: closeModalDelete,
		deleteAccountPlan: deleteAccountPlan
	},
	props: {
		subsidiaryId: [Number, String]
	},
	watch: {
		$route: function $route(newVal) {
			var _this2 = this;

			if (newVal) {
				if (newVal.name === 'accounting-plans') {
					if (this.subsidiaryId) {
						var value = this.companies.find(function (c) {
							return c.id === _this2.subsidiaryId;
						}) || {};
						this.params.subsidiaryId = Number(this.subsidiaryId);
						this.subsidiaryName = value.name;
						this.loadYear(this.params.subsidiaryId);
					}
					this.loadAccounting();
				}
			}
		},

		subsidiaryName: subsidiaryName,
		currentSubsidiary: currentSubsidiary
	}
});

/***/ }),

/***/ 1300:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1301);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(721)("3229d84e", content, true, {});

/***/ }),

/***/ 1301:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(720)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:AvenirRegular;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Regular.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:AvenirBold;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Bold.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:AvenirDemi;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Demi.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.accounting-list[data-v-77a70e1c]{font-family:AvenirRegular!important;font-size:11px!important;padding-left:48px;padding-right:48px}@media(max-width:768px){.accounting-list[data-v-77a70e1c]{margin-bottom:60px;padding-left:10px;padding-right:10px}}.collapse-menu[data-v-77a70e1c]{display:none}@media(max-width:768px){.collapse-menu[data-v-77a70e1c]{display:block;grid-column:4/5;grid-row:1}.collapse-menu .v-menu[data-v-77a70e1c],.collapse-menu[data-v-77a70e1c]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:100%;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.collapse-menu .v-menu[data-v-77a70e1c]{display:-webkit-box;display:-ms-flexbox;display:flex}.collapse-menu .v-menu .v-btn[data-v-77a70e1c]{background-color:#33cfc7;height:25px;margin:0;width:25px}}.menu-content[data-v-77a70e1c]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#f52c18;display:grid;font-family:AvenirRegular;font-size:12px!important;grid-column-gap:3px;grid-template-columns:15px 1fr;width:175px}.menu-content .factory[data-v-77a70e1c]{color:#006edb}.menu-content .edit[data-v-77a70e1c]{color:#33cfc7}.menu-content .blue-icon[data-v-77a70e1c]{color:#2494b7}@media(max-width:768px){.description[data-v-77a70e1c]{background-color:#f2f2f2;display:grid;grid-column:1/3;grid-row:1}}@media(max-width:768px){.actions[data-v-77a70e1c]{background-color:#f2f2f2;grid-column:3/4;grid-row:1}}@media(max-width:768px){.name[data-v-77a70e1c]{display:none}}@media(max-width:768px){.year[data-v-77a70e1c]{background-color:#fff;display:grid;grid-column:1/4;grid-row:2}}.btn[data-v-77a70e1c]{border-radius:30px;color:#fff;height:30px;padding:0 10px;width:90px}.agree[data-v-77a70e1c]{background-color:#006edb;margin-left:10px}.cancel[data-v-77a70e1c]{background-color:#f42b17;margin-right:10px}.btnActions[data-v-77a70e1c]{margin:0;background-color:#33cfc7;height:20px;width:20px}", "", {"version":3,"sources":["/opt/build/repo/src/pages/accounting-plans/page-accounting-plans.vue"],"names":[],"mappings":"AACA,WAAW,0BAA4B,6DAA6D,gBAAmB,kBAAkB,iBAAiB,CACzJ,AACD,WAAW,uBAAyB,0DAA0D,gBAAmB,kBAAkB,iBAAiB,CACnJ,AACD,WAAW,uBAAyB,0DAA0D,gBAAmB,kBAAkB,iBAAiB,CACnJ,AACD,WAAW,yBAA2B,0CAA0C,gBAAmB,iBAAiB,CACnH,AACD,WAAW,sBAAwB,uCAAuC,gBAAmB,iBAAiB,CAC7G,AACD,WAAW,uBAAyB,wCAAwC,gBAAmB,iBAAiB,CAC/G,AACD,WAAW,0BAA4B,8CAA8C,gBAAmB,iBAAiB,CACxH,AACD,WAAW,uBAAyB,2CAA2C,gBAAmB,iBAAiB,CAClH,AACD,WAAW,2BAA6B,+CAA+C,gBAAmB,iBAAiB,CAC1H,AACD,WAAW,wBAA0B,4CAA4C,gBAAmB,iBAAiB,CACpH,AAGD,kCAAkC,oCAAuC,yBAA0B,kBAAkB,kBAAkB,CACtI,AACD,wBACA,kCAAkC,mBAAmB,kBAAkB,kBAAkB,CACxF,CACA,AACD,gCAAgC,YAAY,CAC3C,AACD,wBACA,gCAAkG,cAAc,gBAAgB,UAAW,CAC1I,AACD,wEAFgC,yBAAyB,sBAAsB,mBAAmB,AAAyC,YAAY,wBAAwB,qBAAqB,sBAAsB,CAGzN,AADD,wCAA0G,oBAAoB,oBAAoB,YAAa,CAC9J,AACD,+CAA+C,yBAAyB,YAAY,SAAS,UAAU,CACtG,CACA,AACD,+BAA+B,yBAAyB,sBAAsB,mBAAmB,cAAc,aAAa,0BAA4B,yBAA0B,oBAAoB,+BAA+B,WAAW,CAC/O,AACD,wCAAwC,aAAa,CACpD,AACD,qCAAqC,aAAa,CACjD,AACD,0CAA0C,aAAa,CACtD,AACD,wBACA,8BAA8B,yBAAyB,aAAa,gBAAgB,UAAU,CAC7F,CACA,AACD,wBACA,0BAA0B,yBAAyB,gBAAgB,UAAU,CAC5E,CACA,AACD,wBACA,uBAAuB,YAAY,CAClC,CACA,AACD,wBACA,uBAAuB,sBAAsB,aAAa,gBAAgB,UAAU,CACnF,CACA,AACD,sBAAsB,mBAAmB,WAAW,YAAY,eAAe,UAAU,CACxF,AACD,wBAAwB,yBAAyB,gBAAgB,CAChE,AACD,yBAAyB,yBAAyB,iBAAiB,CAClE,AACD,6BAA6B,SAAS,yBAAyB,YAAY,UAAU,CACpF","file":"page-accounting-plans.vue","sourcesContent":["\n@font-face{font-family:\"AvenirRegular\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Regular.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"AvenirBold\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Bold.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"AvenirDemi\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Demi.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"Lato_regular\";src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_bold\";src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_light\";src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_regular\";src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_bold\";src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_semibold\";src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_light\";src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:normal;font-style:normal\n}\n.btn[data-v-77a70e1c]{border-radius:30px;color:#fff;height:30px;padding:0 10px;width:90px\n}\n.accounting-list[data-v-77a70e1c]{font-family:\"AvenirRegular\" !important;font-size:11px !important;padding-left:48px;padding-right:48px\n}\n@media(max-width: 768px){\n.accounting-list[data-v-77a70e1c]{margin-bottom:60px;padding-left:10px;padding-right:10px\n}\n}\n.collapse-menu[data-v-77a70e1c]{display:none\n}\n@media(max-width: 768px){\n.collapse-menu[data-v-77a70e1c]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:block;grid-column:4/5;grid-row:1;height:100%;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center\n}\n.collapse-menu .v-menu[data-v-77a70e1c]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;height:100%;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center\n}\n.collapse-menu .v-menu .v-btn[data-v-77a70e1c]{background-color:#33cfc7;height:25px;margin:0;width:25px\n}\n}\n.menu-content[data-v-77a70e1c]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#f52c18;display:grid;font-family:\"AvenirRegular\";font-size:12px !important;grid-column-gap:3px;grid-template-columns:15px 1fr;width:175px\n}\n.menu-content .factory[data-v-77a70e1c]{color:#006edb\n}\n.menu-content .edit[data-v-77a70e1c]{color:#33cfc7\n}\n.menu-content .blue-icon[data-v-77a70e1c]{color:#2494b7\n}\n@media(max-width: 768px){\n.description[data-v-77a70e1c]{background-color:#f2f2f2;display:grid;grid-column:1/3;grid-row:1\n}\n}\n@media(max-width: 768px){\n.actions[data-v-77a70e1c]{background-color:#f2f2f2;grid-column:3/4;grid-row:1\n}\n}\n@media(max-width: 768px){\n.name[data-v-77a70e1c]{display:none\n}\n}\n@media(max-width: 768px){\n.year[data-v-77a70e1c]{background-color:#fff;display:grid;grid-column:1/4;grid-row:2\n}\n}\n.btn[data-v-77a70e1c]{border-radius:30px;color:#fff;height:30px;padding:0 10px;width:90px\n}\n.agree[data-v-77a70e1c]{background-color:#006edb;margin-left:10px\n}\n.cancel[data-v-77a70e1c]{background-color:#f42b17;margin-right:10px\n}\n.btnActions[data-v-77a70e1c]{margin:0;background-color:#33cfc7;height:20px;width:20px\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1302:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page-accounting"},[_c('header-page',{attrs:{"actions":"","name":"accountant","title":_vm.title,"value-disabled":_vm.valuesDisabled},on:{"run-action":_vm.runAction}}),_vm._v(" "),_c('app-actions',{attrs:{"value-disabled":_vm.valuesDisabled,"resource-uri":_vm.$route.name},on:{"run-action":_vm.runAction}}),_vm._v(" "),_c('backButtonRoute'),_vm._v(" "),_c('accounting-filter',{attrs:{"companies":_vm.companies,"subsidiary-id":_vm.params.subsidiaryId,"year-accountant-id":_vm.params.yearAccountantId,"years":_vm.years,"hiden-company":""},on:{"filter":function($event){return _vm.filterRows($event)}}}),_vm._v(" "),_c('div',{staticClass:"accounting-list"},[_c('app-table',{staticClass:"mt-3 is-not-selectable",attrs:{"name":"accounting-planes","columns":_vm.columns,"rows":_vm.rows,"last-page":_vm.lastPage,"items-total-quantity":_vm.itemsTotalQuantity,"items-quantity":_vm.rows.length,"current-page":_vm.currentPage},on:{"on-page":_vm.changePage,"on-search-event":function($event){return _vm.onSearchPlan($event)}},scopedSlots:_vm._u([{key:"rows",fn:function(props){return [_c('td',{staticClass:"is-not-selectable description"},[_vm._v("\n\t\t\t\t"+_vm._s(props.row.description)+"\n\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"name"},[_vm._v(_vm._s(props.row.subsidiary.name))]),_vm._v(" "),_c('td',{staticClass:"year"},[_vm._v(_vm._s(props.row.year))]),_vm._v(" "),_c('td',{staticClass:"state"},[_vm._v(_vm._s(props.row.flagActive === 1 ? 'Activo' : 'Inactivo'))]),_vm._v(" "),_c('td',{staticClass:"actions",on:{"click":function($event){$event.stopPropagation();return _vm.stopClick.apply(null, arguments)}}},[_c('app-tooltip-button',{staticClass:"no-movil",attrs:{"img":"/static/img/actions-list/detail.svg","text":"Ver Detalle","width":_vm.iconWidth},on:{"click-icon":function($event){return _vm.goToDetail(props.row)}}}),_vm._v(" "),_c('app-tooltip-button',{staticClass:"no-movil",attrs:{"img":"/static/img/actions-list/square.svg","text":"Clonar Plan de Cuentas","width":_vm.iconWidth},on:{"click-icon":function($event){return _vm.openModal(props.row)}}}),_vm._v(" "),_c('app-tooltip-button',{staticClass:"no-movil",attrs:{"img":"/static/img/actions-list/edit.svg","text":"Editar Plan de Cuentas","width":_vm.iconWidth},on:{"click-icon":function($event){return _vm.edit(props.row.id)}}}),_vm._v(" "),_c('app-tooltip-button',{staticClass:"no-movil",attrs:{"color":"error","icon":"delete","text":"Eliminar Plan de Cuentas"},on:{"click-icon":function($event){return _vm.confirmAccountPlanDeletion(props.row)}}}),_vm._v(" "),_c('div',{staticClass:"collapse-menu"},[_c('v-menu',[_c('v-btn',{attrs:{"slot":"activator","dark":"","icon":""},slot:"activator"},[_c('v-icon',[_vm._v("more_horiz")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{staticClass:"btn-menu-content"},[_c('v-list-tile-title',{staticClass:"menu-content",on:{"click":function($event){return _vm.goToDetail(props.row)}}},[_c('img',{staticClass:"menu-option-icon",attrs:{"src":"/static/img/actions-list/detail.svg","alt":"icono","width":"15px","height":"15px"}}),_vm._v(" "),_c('span',{staticClass:"ml-1 blue-icon"},[_vm._v("Ver Detalle")])])],1),_vm._v(" "),_c('v-list-tile',{staticClass:"btn-menu-content"},[_c('v-list-tile-title',{staticClass:"menu-content",on:{"click":function($event){return _vm.openModal(props.row)}}},[_c('img',{staticClass:"menu-option-icon",attrs:{"src":"/static/img/actions-list/square.svg","alt":"icono","width":"15px","height":"15px"}}),_vm._v(" "),_c('span',{staticClass:"ml-1 factory"},[_vm._v("Clonar Plan de Cuentas")])])],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-title',{staticClass:"menu-content",on:{"click":function($event){return _vm.edit(props.row.id)}}},[_c('img',{staticClass:"menu-option-icon",attrs:{"src":"/static/img/actions-list/edit.svg","alt":"icono","width":"15px","height":"15px"}}),_vm._v(" "),_c('span',{staticClass:"ml-1 edit"},[_vm._v("Editar Plan de Cuentas")])])],1)],1)],1)],1)],1)]}}])})],1),_vm._v(" "),_c('v-dialog',{attrs:{"content-class":"confirmation-dialog","max-width":"400"},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_c('v-card',{staticClass:"pa-4"},[_c('v-card-text',{staticClass:"title text-xs-center pt-4"},[_vm._v(_vm._s(_vm.titleModal))]),_vm._v(" "),_c('v-card-actions',{staticClass:"justify-center pb-4"},[_c('button',{staticClass:"btn cancel",attrs:{"type":"button"},on:{"click":_vm.closeModal}},[_vm._v("\n\t\t\t\t\tNo\n\t\t\t\t")]),_vm._v(" "),_c('button',{staticClass:"btn agree",attrs:{"type":"button"},on:{"click":_vm.onClone}},[_vm._v("\n\t\t\t\t\tSi\n\t\t\t\t")])])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"content-class":"confirmation-dialog","max-width":"400"},model:{value:(_vm.actionDeleteModal.modal),callback:function ($$v) {_vm.$set(_vm.actionDeleteModal, "modal", $$v)},expression:"actionDeleteModal.modal"}},[_c('v-card',{staticClass:"pa-4"},[_c('v-card-text',{staticClass:"title text-xs-center pt-4"},[_vm._v(_vm._s(_vm.actionDeleteModal.titleModal))]),_vm._v(" "),_c('v-card-actions',{staticClass:"justify-center pb-4"},[_c('button',{staticClass:"btn cancel",attrs:{"type":"button"},on:{"click":_vm.closeModalDelete}},[_vm._v("\n\t\t\t\t\tNo\n\t\t\t\t")]),_vm._v(" "),_c('button',{staticClass:"btn agree",attrs:{"type":"button"},on:{"click":_vm.deleteAccountPlan}},[_vm._v("\n\t\t\t\t\tSi\n\t\t\t\t")])])],1)],1),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 727:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_accounting_plans_vue__ = __webpack_require__(1123);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77a70e1c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_accounting_plans_vue__ = __webpack_require__(1302);
function injectStyle (ssrContext) {
  __webpack_require__(1300)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-77a70e1c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_accounting_plans_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77a70e1c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_accounting_plans_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 796:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_app_tooltip_button__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(20);


//
//
//
//
//
//
//
//
//
//
//
//




function backRoute() {
	var getBread = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.getBreadCrumbs));
	getBread.pop();
	var lastRoute = getBread[getBread.length - 1];
	var options = {
		meta: lastRoute.meta,
		params: lastRoute.params,
		query: lastRoute.query
	};
	this.goTo(lastRoute.name, options);
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'back-button-route',
	components: {
		appTooltipButton: __WEBPACK_IMPORTED_MODULE_2__components_shared_app_tooltip_button__["a" /* default */]
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('route', ['getBreadCrumbs'])),
	methods: {
		backRoute: backRoute
	}
});

/***/ }),

/***/ 800:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_action_sidebar__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_accounting_utils_help_component__ = __webpack_require__(827);





var loadData = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
		var _this = this;

		var appCode, uri, params, headers, _ref2, actions;

		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						appCode = 'quipu-admin';
						uri = this.resourceUri;
						params = {
							languages: 'es'
						};
						headers = {
							Accept: 'application/vnd.apiacl.v2+json'
						};
						_context.prev = 4;
						_context.next = 7;
						return this.$httpAcl.get('sidebar/' + appCode + '/resource/' + uri, { params: params, headers: headers });

					case 7:
						_ref2 = _context.sent;
						actions = _ref2.data;

						this.actions = actions.data.map(function (actionSingle) {
							var newAction = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, actionSingle);
							var index = _this.valueDisabled.findIndex(function (val) {
								return val.code === actionSingle.code;
							});
							newAction.name = actionSingle.languages;
							newAction.disabled = index > -1 && _this.valueDisabled[index].disabled;
							return newAction;
						});
						this.newActions = this.actions.splice(0, 3);
						this.actionComplete = actions.data;
						_context.next = 17;
						break;

					case 14:
						_context.prev = 14;
						_context.t0 = _context['catch'](4);

						this.showNotification('Recursos cargados', 'success');

					case 17:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[4, 14]]);
	}));

	return function loadData() {
		return _ref.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function created() {
	this.loadData();
}

function actionDisabled(values) {
	this.actions = this.actions.reduce(function (accum, act) {
		var newAction = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, act);
		var index = values.findIndex(function (v) {
			return v.code === act.code;
		});
		newAction.disabled = index > -1 && values[index].disabled;
		newAction.showMessage = index > -1 ? values[index].showMessage || false : false;
		newAction.message = index > -1 ? values[index].message : null;
		accum.push(newAction);
		return accum;
	}, []);
	this.newActions = this.newActions.reduce(function (accum, act) {
		var newAction = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, act);
		var index = values.findIndex(function (v) {
			return v.code === act.code;
		});
		newAction.disabled = index > -1 && values[index].disabled;
		newAction.showMessage = index > -1 ? values[index].showMessage || false : false;
		newAction.message = index > -1 ? values[index].message : null;
		accum.push(newAction);
		return accum;
	}, []);
}

function openAction(item) {
	if (!item.disabled) {
		if (item.code === 'HELP') {
			var helpIndex = this.actions.findIndex(function (act) {
				return act.code === item.code;
			});
			var newActions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.actions);
			newActions.splice(helpIndex, 1);
			var model = {
				code: item.code,
				actions: newActions
			};
			this.$emit('open-help', model);
		} else {
			this.$emit('run-action', item);
		}
	}
}

function openHelp() {
	this.action = {
		title: this.$route.meta.title,
		code: 'H',
		open: true,
		value: true,
		width: 500
	};
	this.helps = this.actionComplete;
}

function cancelModal() {
	this.action = {
		value: false,
		code: null,
		title: ''
	};
}

function openActionVertical() {
	this.showActionVertical = !this.showActionVertical;
}

function watchRoute(routeValue) {
	if (routeValue) {
		this.loadData();
	}
}

function data() {
	return {
		actions: [],
		helps: [],
		actionComplete: [],
		newActions: [],
		action: {
			value: false,
			code: '',
			open: false,
			title: '',
			width: 600
		},
		showActionVertical: false
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-actions',
	created: created,
	components: {
		actionSidebar: __WEBPACK_IMPORTED_MODULE_4__components_shared_action_sidebar__["a" /* default */],
		helpComponent: __WEBPACK_IMPORTED_MODULE_5__components_accounting_utils_help_component__["a" /* default */]
	},
	methods: {
		cancelModal: cancelModal,
		loadData: loadData,
		openAction: openAction,
		openHelp: openHelp,
		openActionVertical: openActionVertical
	},
	data: data,
	props: {
		resourceUri: {
			required: true,
			type: String
		},
		valueDisabled: {
			default: function _default() {
				return [];
			},
			type: Array
		}
	},
	watch: {
		valueDisabled: {
			deep: true,
			handler: actionDisabled
		},
		$route: watchRoute
	}
});

/***/ }),

/***/ 801:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'help-component',
	props: {
		helps: {
			type: Array,
			default: function _default() {
				return [];
			},
			required: true
		}
	}
});

/***/ }),

/***/ 809:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_back_button_route_vue__ = __webpack_require__(796);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_710017da_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_back_button_route_vue__ = __webpack_require__(812);
function injectStyle (ssrContext) {
  __webpack_require__(810)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-710017da"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_back_button_route_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_710017da_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_back_button_route_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 810:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(811);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(721)("11adcb88", content, true, {});

/***/ }),

/***/ 811:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(720)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:AvenirRegular;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Regular.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:AvenirBold;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Bold.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:AvenirDemi;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Demi.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.back-button[data-v-710017da]{margin-left:50px}", "", {"version":3,"sources":["/opt/build/repo/src/components/shared/back-button-route.vue"],"names":[],"mappings":"AACA,WAAW,0BAA4B,6DAA6D,gBAAmB,kBAAkB,iBAAiB,CACzJ,AACD,WAAW,uBAAyB,0DAA0D,gBAAmB,kBAAkB,iBAAiB,CACnJ,AACD,WAAW,uBAAyB,0DAA0D,gBAAmB,kBAAkB,iBAAiB,CACnJ,AACD,WAAW,yBAA2B,0CAA0C,gBAAmB,iBAAiB,CACnH,AACD,WAAW,sBAAwB,uCAAuC,gBAAmB,iBAAiB,CAC7G,AACD,WAAW,uBAAyB,wCAAwC,gBAAmB,iBAAiB,CAC/G,AACD,WAAW,0BAA4B,8CAA8C,gBAAmB,iBAAiB,CACxH,AACD,WAAW,uBAAyB,2CAA2C,gBAAmB,iBAAiB,CAClH,AACD,WAAW,2BAA6B,+CAA+C,gBAAmB,iBAAiB,CAC1H,AACD,WAAW,wBAA0B,4CAA4C,gBAAmB,iBAAiB,CACpH,AACD,8BAA8B,gBAAgB,CAC7C","file":"back-button-route.vue","sourcesContent":["\n@font-face{font-family:\"AvenirRegular\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Regular.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"AvenirBold\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Bold.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"AvenirDemi\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Demi.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"Lato_regular\";src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_bold\";src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_light\";src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_regular\";src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_bold\";src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_semibold\";src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_light\";src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:normal;font-style:normal\n}\n.back-button[data-v-710017da]{margin-left:50px\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 812:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-tooltip-button',{staticClass:"back-button",attrs:{"img":'/static/img/icons/flecha_izquierda.svg',"width":25,"text":'Regresar'},on:{"click-icon":_vm.backRoute}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 824:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_actions_vue__ = __webpack_require__(800);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71471f8b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_actions_vue__ = __webpack_require__(831);
function injectStyle (ssrContext) {
  __webpack_require__(825)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-71471f8b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_actions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71471f8b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_actions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 825:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(826);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(721)("4889eef0", content, true, {});

/***/ }),

/***/ 826:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(720)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:AvenirRegular;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Regular.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:AvenirBold;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Bold.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:AvenirDemi;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Demi.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.name-action[data-v-71471f8b]{color:#e0e5e8!important;font-family:Opens_semibold;font-size:13px}.btn-add-actions[data-v-71471f8b]{border:1px solid;border-radius:50%;height:25px;margin-left:14px;width:25px}.add-icon[data-v-71471f8b]{position:relative;top:3px}@media(max-width:760px){.app-actions[data-v-71471f8b]{display:none}}.border[data-v-71471f8b]{border:1px solid;height:15px;margin:0 0 0 15px}.width-content[data-v-71471f8b]{margin:0 0 0 auto;width:89%}.btn-add[data-v-71471f8b]{height:25px;width:24px}.btn-app-actions[data-v-71471f8b]{background-color:#fff;border:1px solid #02979b!important;border-radius:5px;-webkit-box-shadow:none;box-shadow:none;color:#02979b;font-family:Opens_semibold;font-size:12px;margin:6px;position:relative;text-transform:uppercase;-webkit-transition:all .5s ease-in-out 0s;transition:all .5s ease-in-out 0s;width:160px}.btn-app-actions.disabled[data-v-71471f8b]{border:1px solid #c8c8c8!important;color:#c8c8c8!important;cursor:not-allowed}.btn-app-actions[data-v-71471f8b]:not(.disabled):hover{background-color:#02979b;color:#fff}.btn-app-actions:not(.disabled):hover .content-images-action .img-resource[data-v-71471f8b]{filter:brightness(0) invert(1);-webkit-filter:brightness(0) invert(1);-moz-filter:brightness(0) invert(1)}.message-action[data-v-71471f8b]{background-color:#fff;border:1px solid;border-radius:5px;-webkit-box-shadow:0 2px 4px 0 hsla(0,0%,62%,.5);box-shadow:0 2px 4px 0 hsla(0,0%,62%,.5);display:none;font-size:12px;left:-95px;padding:15px;position:absolute;text-transform:none;top:51px;-webkit-transition:all .5s ease-in-out 0s;transition:all .5s ease-in-out 0s;z-index:2;width:109%}.message-action[data-v-71471f8b]:before{background:#fff;border:1px solid;border-bottom-width:0;border-right-width:0;content:\"\";height:15px;left:60%;position:absolute;top:-9px;width:15px;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.bold[data-v-71471f8b]{font-family:Opens_semibold}.message-action-list[data-v-71471f8b]{font-size:12px;position:absolute}.img-resource[data-v-71471f8b]{-webkit-transition:all .5s ease-in-out 0s;transition:all .5s ease-in-out 0s}.img-resource.disabled[data-v-71471f8b]{filter:grayscale(100%);-webkit-filter:grayscale(100%);-moz-filter:grayscale(100%)}.content-images-action.show-description:hover .img-resource-help[data-v-71471f8b],.content-images-action.show-description:hover .message-action[data-v-71471f8b]{display:block}.content-images-action.show-description:hover .img-resource[data-v-71471f8b]{display:none}.img-gray[data-v-71471f8b]{filter:grayscale(100%);-webkit-filter:grayscale(100%);-moz-filter:grayscale(100%)}.img-white[data-v-71471f8b]{filter:brightness(0) invert(1);-webkit-filter:brightness(0) invert(1);-moz-filter:brightness(0) invert(1)}.img-resource-help[data-v-71471f8b]{display:none}.content-action-vertical[data-v-71471f8b]{position:relative}.content-list-action-vertical[data-v-71471f8b]{background-color:#fff;border:1px solid #ebebeb;border-radius:5px;-webkit-box-shadow:0 2px 5px 0 rgba(0,0,0,.05);box-shadow:0 2px 5px 0 rgba(0,0,0,.05);left:-135%;padding:6px;position:absolute;top:41px;width:197px;z-index:4}.content-list-action-vertical.open-action[data-v-71471f8b]{display:block}.content-list-action-vertical.close-action[data-v-71471f8b]{display:none}.content-list-action-vertical[data-v-71471f8b]:before{background:#fff;border:1px solid #ebebeb;border-bottom-width:0;border-right-width:0;content:\"\";height:15px;left:41%;position:absolute;top:-9px;width:15px;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.content-btn-vertical[data-v-71471f8b]{padding:8px 0;display:-webkit-box;display:-ms-flexbox;display:flex}.content-btn-vertical-text[data-v-71471f8b]{color:#e0e5e8;font-size:12px;text-align:left;text-transform:uppercase}.content-btn-vertical-text.disabled[data-v-71471f8b]{color:#c8c8c8}.content-btn-vertical.disabled[data-v-71471f8b]{cursor:not-allowed}.img-veritical.disabled[data-v-71471f8b]{filter:grayscale(100%);-webkit-filter:grayscale(100%);-moz-filter:grayscale(100%)}.content-image-message[data-v-71471f8b]{position:relative}.content-image-message:hover .message-action-vertical[data-v-71471f8b]{display:block}.content-image-message:hover .img-veritical[data-v-71471f8b]{display:none}.content-image-message:hover .img-resource-help-vertical[data-v-71471f8b]{display:block}.message-action-vertical[data-v-71471f8b]{background-color:#fff;border:1px solid;border-radius:5px;-webkit-box-shadow:0 2px 4px 0 hsla(0,0%,62%,.5);box-shadow:0 2px 4px 0 hsla(0,0%,62%,.5);font-size:12px;display:none;padding:6px;position:absolute;right:29px;top:-14px;width:178px}.message-action-vertical[data-v-71471f8b]:before{background:#fff;border:1px solid;border-bottom-width:0;border-left-width:0;content:\"\";height:15px;position:absolute;right:-8px;top:11px;width:15px;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.img-resource-help-vertical[data-v-71471f8b]{display:none;height:24px}.new-indicator[data-v-71471f8b]{right:1px;position:absolute;top:.5px}", "", {"version":3,"sources":["/opt/build/repo/src/components/shared/app-actions/app-actions.vue"],"names":[],"mappings":"AACA,WAAW,0BAA4B,6DAA6D,gBAAmB,kBAAkB,iBAAiB,CACzJ,AACD,WAAW,uBAAyB,0DAA0D,gBAAmB,kBAAkB,iBAAiB,CACnJ,AACD,WAAW,uBAAyB,0DAA0D,gBAAmB,kBAAkB,iBAAiB,CACnJ,AACD,WAAW,yBAA2B,0CAA0C,gBAAmB,iBAAiB,CACnH,AACD,WAAW,sBAAwB,uCAAuC,gBAAmB,iBAAiB,CAC7G,AACD,WAAW,uBAAyB,wCAAwC,gBAAmB,iBAAiB,CAC/G,AACD,WAAW,0BAA4B,8CAA8C,gBAAmB,iBAAiB,CACxH,AACD,WAAW,uBAAyB,2CAA2C,gBAAmB,iBAAiB,CAClH,AACD,WAAW,2BAA6B,+CAA+C,gBAAmB,iBAAiB,CAC1H,AACD,WAAW,wBAA0B,4CAA4C,gBAAmB,iBAAiB,CACpH,AACD,8BAA8B,wBAAyB,2BAA6B,cAAc,CACjG,AACD,kCAAkC,iBAAiB,kBAAkB,YAAY,iBAAiB,UAAU,CAC3G,AACD,2BAA2B,kBAAkB,OAAO,CACnD,AACD,wBACA,8BAA8B,YAAY,CACzC,CACA,AACD,yBAAyB,iBAAiB,YAAY,iBAAiB,CACtE,AACD,gCAAgC,kBAAkB,SAAS,CAC1D,AACD,0BAA0B,YAAY,UAAU,CAC/C,AACD,kCAAkC,sBAAsB,mCAAoC,kBAAkB,wBAAwB,gBAAgB,cAAc,2BAA6B,eAAe,WAAW,kBAAkB,yBAAyB,0CAA0C,kCAAkC,WAAW,CAC5V,AACD,2CAA2C,mCAAoC,wBAAyB,kBAAkB,CACzH,AACD,uDAAuD,yBAAyB,UAAU,CACzF,AACD,4FAA4F,+BAA+B,uCAAuC,mCAAmC,CACpM,AACD,iCAAiC,sBAAsB,iBAAiB,kBAAkB,iDAAoD,yCAA4C,aAAa,eAAe,WAAW,aAAa,kBAAkB,oBAAoB,SAAS,0CAA0C,kCAAkC,UAAU,UAAU,CAC5X,AACD,wCAAyC,gBAAgB,iBAAiB,sBAAsB,qBAAqB,WAAW,YAAY,SAAS,kBAAkB,SAAS,WAAW,gCAAgC,uBAAuB,CACjP,AACD,uBAAuB,0BAA4B,CAClD,AACD,sCAAsC,eAAe,iBAAiB,CACrE,AACD,+BAA+B,0CAA0C,iCAAiC,CACzG,AACD,wCAAwC,uBAAuB,+BAA+B,2BAA2B,CACxH,AAGD,iKAAkF,aAAa,CAC9F,AACD,6EAA6E,YAAY,CACxF,AACD,2BAA2B,uBAAuB,+BAA+B,2BAA2B,CAC3G,AACD,4BAA4B,+BAA+B,uCAAuC,mCAAmC,CACpI,AACD,oCAAoC,YAAY,CAC/C,AACD,0CAA0C,iBAAiB,CAC1D,AACD,+CAA+C,sBAAsB,yBAAyB,kBAAkB,+CAA+C,uCAAuC,WAAW,YAAY,kBAAkB,SAAS,YAAY,SAAS,CAC5Q,AACD,2DAA2D,aAAa,CACvE,AACD,4DAA4D,YAAY,CACvE,AACD,sDAAuD,gBAAgB,yBAAyB,sBAAsB,qBAAqB,WAAW,YAAY,SAAS,kBAAkB,SAAS,WAAW,gCAAgC,uBAAuB,CACvQ,AACD,uCAAuC,cAAc,oBAAoB,oBAAoB,YAAY,CACxG,AACD,4CAA4C,cAAc,eAAe,gBAAgB,wBAAwB,CAChH,AACD,qDAAqD,aAAa,CACjE,AACD,gDAAgD,kBAAkB,CACjE,AACD,yCAAyC,uBAAuB,+BAA+B,2BAA2B,CACzH,AACD,wCAAwC,iBAAiB,CACxD,AACD,uEAAuE,aAAa,CACnF,AACD,6DAA6D,YAAY,CACxE,AACD,0EAA0E,aAAa,CACtF,AACD,0CAA0C,sBAAsB,iBAAiB,kBAAkB,iDAAoD,yCAA4C,eAAe,aAAa,YAAY,kBAAkB,WAAW,UAAU,WAAW,CAC5R,AACD,iDAAkD,gBAAgB,iBAAiB,sBAAsB,oBAAoB,WAAW,YAAY,kBAAkB,WAAW,SAAS,WAAW,gCAAgC,uBAAuB,CAC3P,AACD,6CAA6C,aAAa,WAAW,CACpE,AACD,gCAAgC,UAAU,kBAAkB,QAAQ,CACnE","file":"app-actions.vue","sourcesContent":["\n@font-face{font-family:\"AvenirRegular\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Regular.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"AvenirBold\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Bold.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"AvenirDemi\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Demi.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"Lato_regular\";src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_bold\";src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_light\";src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_regular\";src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_bold\";src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_semibold\";src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_light\";src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:normal;font-style:normal\n}\n.name-action[data-v-71471f8b]{color:#e0e5e8 !important;font-family:\"Opens_semibold\";font-size:13px\n}\n.btn-add-actions[data-v-71471f8b]{border:solid 1px;border-radius:50%;height:25px;margin-left:14px;width:25px\n}\n.add-icon[data-v-71471f8b]{position:relative;top:3px\n}\n@media(max-width: 760px){\n.app-actions[data-v-71471f8b]{display:none\n}\n}\n.border[data-v-71471f8b]{border:1px solid;height:15px;margin:0 0 0 15px\n}\n.width-content[data-v-71471f8b]{margin:0 0 0 auto;width:89%\n}\n.btn-add[data-v-71471f8b]{height:25px;width:24px\n}\n.btn-app-actions[data-v-71471f8b]{background-color:#fff;border:1px solid #02979b !important;border-radius:5px;-webkit-box-shadow:none;box-shadow:none;color:#02979b;font-family:\"Opens_semibold\";font-size:12px;margin:6px;position:relative;text-transform:uppercase;-webkit-transition:all .5s ease-in-out 0s;transition:all .5s ease-in-out 0s;width:160px\n}\n.btn-app-actions.disabled[data-v-71471f8b]{border:1px solid #c8c8c8 !important;color:#c8c8c8 !important;cursor:not-allowed\n}\n.btn-app-actions[data-v-71471f8b]:not(.disabled):hover{background-color:#02979b;color:#fff\n}\n.btn-app-actions:not(.disabled):hover .content-images-action .img-resource[data-v-71471f8b]{filter:brightness(0) invert(1);-webkit-filter:brightness(0) invert(1);-moz-filter:brightness(0) invert(1)\n}\n.message-action[data-v-71471f8b]{background-color:#fff;border:1px solid;border-radius:5px;-webkit-box-shadow:0 2px 4px 0 rgba(157,157,157,.5);box-shadow:0 2px 4px 0 rgba(157,157,157,.5);display:none;font-size:12px;left:-95px;padding:15px;position:absolute;text-transform:none;top:51px;-webkit-transition:all .5s ease-in-out 0s;transition:all .5s ease-in-out 0s;z-index:2;width:109%\n}\n.message-action[data-v-71471f8b]::before{background:#fff;border:1px solid;border-bottom-width:0;border-right-width:0;content:\"\";height:15px;left:60%;position:absolute;top:-9px;width:15px;-webkit-transform:rotate(45deg);transform:rotate(45deg)\n}\n.bold[data-v-71471f8b]{font-family:\"Opens_semibold\"\n}\n.message-action-list[data-v-71471f8b]{font-size:12px;position:absolute\n}\n.img-resource[data-v-71471f8b]{-webkit-transition:all .5s ease-in-out 0s;transition:all .5s ease-in-out 0s\n}\n.img-resource.disabled[data-v-71471f8b]{filter:grayscale(100%);-webkit-filter:grayscale(100%);-moz-filter:grayscale(100%)\n}\n.content-images-action.show-description:hover .message-action[data-v-71471f8b]{display:block\n}\n.content-images-action.show-description:hover .img-resource-help[data-v-71471f8b]{display:block\n}\n.content-images-action.show-description:hover .img-resource[data-v-71471f8b]{display:none\n}\n.img-gray[data-v-71471f8b]{filter:grayscale(100%);-webkit-filter:grayscale(100%);-moz-filter:grayscale(100%)\n}\n.img-white[data-v-71471f8b]{filter:brightness(0) invert(1);-webkit-filter:brightness(0) invert(1);-moz-filter:brightness(0) invert(1)\n}\n.img-resource-help[data-v-71471f8b]{display:none\n}\n.content-action-vertical[data-v-71471f8b]{position:relative\n}\n.content-list-action-vertical[data-v-71471f8b]{background-color:#fff;border:solid 1px #ebebeb;border-radius:5px;-webkit-box-shadow:0 2px 5px 0 rgba(0,0,0,.05);box-shadow:0 2px 5px 0 rgba(0,0,0,.05);left:-135%;padding:6px;position:absolute;top:41px;width:197px;z-index:4\n}\n.content-list-action-vertical.open-action[data-v-71471f8b]{display:block\n}\n.content-list-action-vertical.close-action[data-v-71471f8b]{display:none\n}\n.content-list-action-vertical[data-v-71471f8b]::before{background:#fff;border:1px solid #ebebeb;border-bottom-width:0;border-right-width:0;content:\"\";height:15px;left:41%;position:absolute;top:-9px;width:15px;-webkit-transform:rotate(45deg);transform:rotate(45deg)\n}\n.content-btn-vertical[data-v-71471f8b]{padding:8px 0;display:-webkit-box;display:-ms-flexbox;display:flex\n}\n.content-btn-vertical-text[data-v-71471f8b]{color:#e0e5e8;font-size:12px;text-align:left;text-transform:uppercase\n}\n.content-btn-vertical-text.disabled[data-v-71471f8b]{color:#c8c8c8\n}\n.content-btn-vertical.disabled[data-v-71471f8b]{cursor:not-allowed\n}\n.img-veritical.disabled[data-v-71471f8b]{filter:grayscale(100%);-webkit-filter:grayscale(100%);-moz-filter:grayscale(100%)\n}\n.content-image-message[data-v-71471f8b]{position:relative\n}\n.content-image-message:hover .message-action-vertical[data-v-71471f8b]{display:block\n}\n.content-image-message:hover .img-veritical[data-v-71471f8b]{display:none\n}\n.content-image-message:hover .img-resource-help-vertical[data-v-71471f8b]{display:block\n}\n.message-action-vertical[data-v-71471f8b]{background-color:#fff;border:1px solid;border-radius:5px;-webkit-box-shadow:0 2px 4px 0 rgba(157,157,157,.5);box-shadow:0 2px 4px 0 rgba(157,157,157,.5);font-size:12px;display:none;padding:6px;position:absolute;right:29px;top:-14px;width:178px\n}\n.message-action-vertical[data-v-71471f8b]::before{background:#fff;border:1px solid;border-bottom-width:0;border-left-width:0;content:\"\";height:15px;position:absolute;right:-8px;top:11px;width:15px;-webkit-transform:rotate(45deg);transform:rotate(45deg)\n}\n.img-resource-help-vertical[data-v-71471f8b]{display:none;height:24px\n}\n.new-indicator[data-v-71471f8b]{right:1px;position:absolute;top:.5px\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 827:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_help_component_vue__ = __webpack_require__(801);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c459fd2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_help_component_vue__ = __webpack_require__(830);
function injectStyle (ssrContext) {
  __webpack_require__(828)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6c459fd2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_help_component_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c459fd2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_help_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 828:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(829);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(721)("7dbef01e", content, true, {});

/***/ }),

/***/ 829:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(720)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:AvenirRegular;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Regular.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:AvenirBold;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Bold.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:AvenirDemi;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Demi.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.help[data-v-6c459fd2]{font-size:14px}.article[data-v-6c459fd2]{margin:20px 0}.article-title[data-v-6c459fd2]{border-bottom:1px solid #fafcff;padding-bottom:8px}.article-description[data-v-6c459fd2]{margin:25px 0 10px}.list-none[data-v-6c459fd2]{list-style:none!important}", "", {"version":3,"sources":["/opt/build/repo/src/components/accounting/utils/help-component.vue"],"names":[],"mappings":"AACA,WAAW,0BAA4B,6DAA6D,gBAAmB,kBAAkB,iBAAiB,CACzJ,AACD,WAAW,uBAAyB,0DAA0D,gBAAmB,kBAAkB,iBAAiB,CACnJ,AACD,WAAW,uBAAyB,0DAA0D,gBAAmB,kBAAkB,iBAAiB,CACnJ,AACD,WAAW,yBAA2B,0CAA0C,gBAAmB,iBAAiB,CACnH,AACD,WAAW,sBAAwB,uCAAuC,gBAAmB,iBAAiB,CAC7G,AACD,WAAW,uBAAyB,wCAAwC,gBAAmB,iBAAiB,CAC/G,AACD,WAAW,0BAA4B,8CAA8C,gBAAmB,iBAAiB,CACxH,AACD,WAAW,uBAAyB,2CAA2C,gBAAmB,iBAAiB,CAClH,AACD,WAAW,2BAA6B,+CAA+C,gBAAmB,iBAAiB,CAC1H,AACD,WAAW,wBAA0B,4CAA4C,gBAAmB,iBAAiB,CACpH,AACD,uBAAuB,cAAc,CACpC,AACD,0BAA0B,aAAa,CACtC,AACD,gCAAgC,gCAAgC,kBAAkB,CACjF,AACD,sCAAsC,kBAAkB,CACvD,AACD,4BAA4B,yBAA0B,CACrD","file":"help-component.vue","sourcesContent":["\n@font-face{font-family:\"AvenirRegular\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Regular.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"AvenirBold\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Bold.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"AvenirDemi\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Demi.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"Lato_regular\";src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_bold\";src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_light\";src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_regular\";src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_bold\";src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_semibold\";src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_light\";src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:normal;font-style:normal\n}\n.help[data-v-6c459fd2]{font-size:14px\n}\n.article[data-v-6c459fd2]{margin:20px 0\n}\n.article-title[data-v-6c459fd2]{border-bottom:1px solid #fafcff;padding-bottom:8px\n}\n.article-description[data-v-6c459fd2]{margin:25px 0 10px\n}\n.list-none[data-v-6c459fd2]{list-style:none !important\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 830:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"help",attrs:{"row":"","mt-4":"","d-flex":"","justify-center":""}},[_c('v-flex',{attrs:{"xs10":""}},_vm._l((_vm.helps),function(help,indexH){return _c('article',{key:indexH,staticClass:"article mb-3"},[_c('v-layout',{staticClass:"article-title",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs1":""}},[_c('img',{attrs:{"src":help.pathIcon,"alt":help.languages}})]),_vm._v(" "),_c('v-flex',[_c('h3',[_vm._v(_vm._s(help.languages))])])],1),_vm._v(" "),_c('section',{staticClass:"article-description"},[_c('h4',{staticClass:"article-description_title"},[_vm._v("Descripción")]),_vm._v(" "),_c('p',{staticClass:"article-description_content"},[_vm._v(_vm._s(help.description))])]),_vm._v(" "),_c('span',[_c('h4',{staticClass:"article-description_title"},[_vm._v("Tutorial:")]),_vm._v(" "),_c('a',{attrs:{"href":help.link,"target":"_blank"}},[_vm._v(_vm._s(help.link))])]),_vm._v(" "),_c('h4',{staticClass:"article-description_title mt-2"},[_vm._v("Manuales:")]),_vm._v(" "),_c('ul',{staticClass:"list-none"},_vm._l((help.manuals),function(man,index){return _c('li',{key:index},[_c('a',{attrs:{"href":man.file,"target":"_blank"}},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(man.file)+"\n\t\t\t\t\t")])])}),0)],1)}),0)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 831:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{staticClass:"app-actions",attrs:{"justify-end":""}},[_c('v-layout',[_c('v-flex',[(this.actionComplete.length > 0)?_c('v-layout',{staticClass:"px-5 width-content",attrs:{"row":"","align-center":"","justify-end":""}},[_vm._l((_vm.newActions),function(item,index){return _c('div',{key:index,staticClass:"border-right"},[_c('button',{staticClass:"btn-app-actions",class:{ 'disabled': item.disabled },attrs:{"type":"button","color":"white"},on:{"click":function($event){return _vm.openAction(item)}}},[_c('v-layout',[_c('v-flex',{staticClass:"content-images-action",class:{'show-description': item.description.length > 0},attrs:{"xs2":"","py-2":"","pl-2":""}},[(item.pathIcon)?_c('img',{staticClass:"img-resource mr-2",class:{ 'disabled': item.disabled },attrs:{"src":item.pathIcon,"alt":item.name,"height":"16","width":"13"}}):_vm._e(),_vm._v(" "),(item.description.length > 0)?_c('img',{staticClass:"img-resource-help",class:[item.disabled ? 'img-gray' : 'img-white'],attrs:{"src":"/static/img/help-action.svg","alt":"ayuda","height":"15"}}):_vm._e(),_vm._v(" "),(item.description.length > 0)?_c('div',{staticClass:"message-action"},[_c('p',{staticClass:"mb-1 primary--text bold"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(item.description))])]):_vm._e()]),_vm._v(" "),_c('v-flex',{attrs:{"xs10":"","py-2":"","pr-2":""}},[(item.flagNew)?_c('app-tooltip-button',{staticClass:"new-indicator",attrs:{"color":"info","height":"10","icon":"fiber_manual_record","text":item.newTitle || 'Nuevo'}}):_vm._e(),_vm._v(" "),(item.name.length > 14)?_c('v-tooltip',{attrs:{"top":""}},[_c('span',{attrs:{"slot":"activator"},slot:"activator"},[_vm._v(_vm._s(_vm._f("limitTo")(item.name,14)))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.name))])]):_c('span',[_vm._v(_vm._s(item.name))])],1)],1)],1)])}),_vm._v(" "),(this.actions.length > 0)?_c('div',{staticClass:"content-action-vertical"},[_c('v-btn',{staticClass:"btn-help",attrs:{"color":"primary","fab":"","small":""},on:{"click":_vm.openActionVertical}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-icon',{staticClass:"add-icon",attrs:{"slot":"activator","color":"white"},slot:"activator"},[_vm._v("add")]),_vm._v(" "),_c('span',[_vm._v("Mas opciones")])],1)],1),_vm._v(" "),_c('div',{staticClass:"content-list-action-vertical",class:[_vm.showActionVertical ? 'open-action' : 'close-action']},_vm._l((_vm.actions),function(item,index){return _c('div',{key:index},[_c('button',{staticClass:"content-btn-vertical",class:{'disabled': item.disabled},on:{"click":function($event){return _vm.openAction(item)}}},[_c('div',{staticClass:"mr-2 content-image-message"},[_c('div',[(item.pathIcon)?_c('img',{staticClass:"img-veritical",class:{'disabled': item.disabled},attrs:{"src":item.pathIcon,"alt":item.name,"height":"16","width":"13"}}):_vm._e(),_vm._v(" "),_c('img',{staticClass:"img-resource-help-vertical",class:{'img-gray': item.disabled},attrs:{"src":"/static/img/help-action.svg","alt":"ayuda","height":"16","width":"13"}})]),_vm._v(" "),(item.description.length > 0)?_c('div',{staticClass:"message-action-vertical"},[_c('p',{staticClass:"mb-1 primary--text bold"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(item.description))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"content-btn-vertical-text",class:{'disabled': item.disabled}},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(item.name)+"\n\t\t\t\t\t\t\t\t")])])])}),0)],1):_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"btn-help",attrs:{"color":"success","fab":"","small":""},on:{"click":_vm.openHelp}},[_c('img',{attrs:{"src":"/static/icon/btn-help-center.svg"}})])],2):_vm._e()],1)],1),_vm._v(" "),_c('action-sidebar',{attrs:{"help-actions":_vm.newActions,"title":_vm.action.title,"value":_vm.action.value,"width":_vm.action.width},on:{"close-modal":_vm.cancelModal}},[_c('help-component',{attrs:{"helps":_vm.helps}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 945:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function setData(val, model) {
	this.$emit('filter', { value: val, model: model });
}

function newSubsidiaryId() {
	return this.subsidiaryId;
}

function newYearId() {
	return this.yearAccountantId;
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'accounting-filter',
	components: {
		BaseSelect: function BaseSelect() {
			return __webpack_require__.e/* import() */(50/* duplicate */).then(__webpack_require__.bind(null, 766));
		}
	},
	computed: {
		newSubsidiaryId: newSubsidiaryId,
		newYearId: newYearId
	},
	methods: {
		setData: setData
	},
	props: {
		column: {
			default: false,
			type: Boolean
		},
		companies: {
			default: function _default() {
				return [];
			},
			type: Array
		},
		disabledYears: {
			default: false,
			type: Boolean
		},
		subsidiaryId: [Number, String],
		yearAccountantId: [Number, String],
		years: {
			default: function _default() {
				return [];
			},
			type: Array
		},
		hidenCompany: {
			default: false,
			type: Boolean
		}
	}
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/37.6553854ccea9b9df4188.js